import React from "react";
import ButtonOrang from "./ButtonOrang";

export default function HeroComexButton({
  titulo,
  subtitulo,
  imagen,
  video,
  height = "h-[460px]",
  buttonText,
  buttonLink,
}) {
  const urlApi = "https://api.institucional.global.sidom.io";
  return (
    <section
      className={`relative w-full ${height} flex items-center justify-center overflow-hidden`}
    >
      <div className="">
        {video ? (
          <video
            className="absolute top-0 left-0 w-full h-full object-cover z-0"
            autoPlay
            loop
            muted
          >
            <source src={`${urlApi}${video}`} type="video/mp4" />
          </video>
        ) : (
          <img
            src={`${urlApi}${imagen}`}
            alt="Puerto y autos Comex"
            className="absolute top-0 left-0 w-full h-screen object-cover z-0"
            draggable={false}
          />
        )}
        {/* Overlay oscuro */}
        <div className="absolute top-0 left-0 w-full h-full bg-sidom-blue/50 z-1" />

        <div className="container line-clamp-1 mt-20 z-20 w-full flex flex-col items-center justify-center px-2">
          <h1 className="text-sidom-light text-4xl  font-extrabold text-center mb-5 drop-shadow-lg">
            {titulo}
          </h1>
          <p className="text-sidom-light text-base md:text-lg lg:text-xl text-center max-w-4xl mx-auto drop-shadow mb-4">
            {subtitulo}
          </p>
          {buttonText && <ButtonOrang text={buttonText} link={buttonLink} />}
        </div>
      </div>
    </section>
  );
}
